import HelperUtils from '@shared/utils/HelperUtils';
import NavRoutes from './route/NavRoutes';

export const PAGINATION_SIZE_OPTIONS = [50];

export const CUSTOM_PAGINATION_SIZE_OPTIONS = {
  CHECK_FN_PD: [50],
  NOTIFICATION_HISTORY: [50],
  PAYMENT_HISTORY: [50],
  ACTION_HISTORY: [100],
  CCM_UPCOMING_APPOINTMENTS: [10],
  TICKETING_SYSTEM: [15],
  SCHEDULE_JOB_PAGE_SIZE: [15],
  HOLIDAYS_LIST_PAGE_SIZE: [100],
  USERS_LIST_PAGE_SIZE: [20],
  EMR_REQUEST_LOGS_PAGE_SIZE: [20],
  CCM_PATIENT_TIME_LOGS: [20]
};

export const PAGINATION_SIZE = {
  CHECK_FN_PD: 50,
  NOTIFICATION_HISTORY: 50,
  PAYMENT_HISTORY: 20,
  DUE_INVOICES: 50,
  PATIENTS: 50,
  ACTION_HISTORY: 100,
  MESSAGES: 20,
  TICKETING_SYSTEM: 15,
  APPOINTMENTS: 5,
  CCM_UPCOMING_APPOINTMENTS: 10,
  ELIGIBILITY_VERIFICATION_LOGS: 10,
  TICKETING_ACTION_HISTORY: 20,
  CCM_PATIENT_TIME_LOGS: 20
};

export const ClinicTypes = {
  PEDIATRIC: 'Pediatric',
  NON_PEDIATRIC: 'Non Pediatric',
  ALLERGY_AND_IMMUNOLOGY: 'Allergy and Immunology',
  ANETHESIOLOGY: 'Anesthesiology',
  CARDIOLOGY: 'Cardiology',
  CRITICAL_CARE_MEDICINE: 'Critical Care Medicine',
  DERMATOLOGY: 'Dermatology',
  ENDOCRINOLOGY: 'Endocrinology',
  GASTROENTEROLOGY: 'Gastroenterology',
  GENERAL_SURGERY: 'General Surgery',
  GERIATRICS: 'Geriatrics',
  HEMATOLOGY: 'Hematology',
  INFECTIOUS_DISEASE: 'Infectious Disease',
  NEPHROLOGY: 'Nephrology',
  NEUROLOGY: 'Neurology',
  NEUROSURGERY: 'Neurosurgery',
  OBSTETRICS_AND_GYNECOLOGY: 'Obstetrics and Gynecology',
  ONCOLOGY: 'Oncology',
  OPHTHALMOLOGY: 'Ophthalmology',
  ORTHOPEDIC_SURGERY: 'Orthopedic Surgery',
  OTOLARYNGOLOGY: 'Otolaryngology',
  PAIN_MANAGEMENT: 'Pain Management',
  PATHOLOGY: 'Pathology',
  PHYSICAL_MEDICINE_AND_REHABILITATION: 'Physical Medicine and Rehabilitation',
  PLASTIC_SURGERY: 'Plastic Surgery',
  PSYCHIATRY: 'Psychiatry',
  PULMONOLOGY: 'Pulmonology',
  RADIOLOGY: 'Radiology',
  RHEUMATOLOGY: 'Rheumatology',
  UROLOGY: 'Urology',
  OTHERS: 'Others'
};

export const ClinicTypesArray = [
  {name: 'Pediatric', value: ClinicTypes.PEDIATRIC},
  {name: 'Non Pediatric', value: ClinicTypes.NON_PEDIATRIC},
  {name: 'Allergy and Immunology', value: ClinicTypes.ALLERGY_AND_IMMUNOLOGY},
  {name: 'Anesthesiology', value: ClinicTypes.ANETHESIOLOGY},
  {name: 'Cardiology', value: ClinicTypes.CARDIOLOGY},
  {name: 'Critical Care Medicine', value: ClinicTypes.CRITICAL_CARE_MEDICINE},
  {name: 'Dermatology', value: ClinicTypes.DERMATOLOGY},
  {name: 'Endocrinology', value: ClinicTypes.ENDOCRINOLOGY},
  {name: 'Gastroenterology', value: ClinicTypes.GASTROENTEROLOGY},
  {name: 'General Surgery', value: ClinicTypes.GENERAL_SURGERY},
  {name: 'Geriatrics', value: ClinicTypes.GERIATRICS},
  {name: 'Hematology', value: ClinicTypes.HEMATOLOGY},
  {name: 'Infectious Disease', value: ClinicTypes.INFECTIOUS_DISEASE},
  {name: 'Nephrology', value: ClinicTypes.NEPHROLOGY},
  {name: 'Neurology', value: ClinicTypes.NEUROLOGY},
  {name: 'Neurosurgery', value: ClinicTypes.NEUROSURGERY},
  {
    name: 'Obstetrics and Gynecology',
    value: ClinicTypes.OBSTETRICS_AND_GYNECOLOGY
  },
  {name: 'Oncology', value: ClinicTypes.ONCOLOGY},
  {name: 'Ophthalmology', value: ClinicTypes.OPHTHALMOLOGY},
  {name: 'Orthopedic Surgery', value: ClinicTypes.ORTHOPEDIC_SURGERY},
  {name: 'Otolaryngology', value: ClinicTypes.OTOLARYNGOLOGY},
  {name: 'Pain Management', value: ClinicTypes.PAIN_MANAGEMENT},
  {name: 'Pathology', value: ClinicTypes.PATHOLOGY},
  {
    name: 'Physical Medicine and Rehabilitation',
    value: ClinicTypes.PHYSICAL_MEDICINE_AND_REHABILITATION
  },
  {name: 'Plastic Surgery', value: ClinicTypes.PLASTIC_SURGERY},
  {name: 'Psychiatry', value: ClinicTypes.PSYCHIATRY},
  {name: 'Pulmonology', value: ClinicTypes.PULMONOLOGY},
  {name: 'Radiology', value: ClinicTypes.RADIOLOGY},
  {name: 'Rheumatology', value: ClinicTypes.RHEUMATOLOGY},
  {name: 'Urology', value: ClinicTypes.UROLOGY},
  {name: 'Others', value: ClinicTypes.OTHERS}
];

export const FN_PD_AMOUNT_DEFAULT = '30';
export const FN_PD_STATEMENT_DEFAULT = '2';

export const formPracticePaymentLink = (code: string): string => {
  if (!code) return '';
  return HelperUtils.generateRouteURL({
    path: `/${code}`
  });
};

export const formShareAppointmentPracticeLink = (code: string): string => {
  if (!code) return '';
  return HelperUtils.generateRouteURL({
    path: `/${code}/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}`
  });
};

export const formSharePracticeAgentAppointmentLink = (code: string): string => {
  if (!code) return '';
  return HelperUtils.generateRouteURL({
    path: `/${NavRoutes.PUBLIC.VOICE_ASSISTANT}/${code}`
  });
};

export const MAX_PATIENT_FILE_SIZES: Record<
  string,
  {bytes: number; formattedSize: string}
> = {
  xlsx: {
    bytes: 20 * 1024 * 1024,
    formattedSize: '20 MB'
  }
};

export const MAX_INSURANCE_IMAGE_SIZE = {
  bytes: 10 * 1024 * 1024,
  formattedSize: '10 MB'
};

export const TEMPLATE_FILE_NAMES = {
  GENERIC_PATIENTS_FILE_NAME: 'generic-emr-patient-file',
  GENERIC_STATEMENTS_FILE_NAME: 'generic-emr-statement-file',
  GENERIC_MESSAGE_PATIENT_TEMPLATE: 'messages_patient_template',
  PROVIDER_IMPORT_TEMPLATE: 'health-care-providers',
  APPOINTMENT_SLOTS_IMPORT_TEMPLATE: 'practice-appointment-slots',
  APPOINTMENT_TYPE_EMR_MAPPING_IMPORT_TEMPLATE: 'appointment-type-emr-mapping'
};

export const MAX_DISPLAY_CHARACTERS = 30;
